import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next';
import { useDeleteVasanItems, useGetAllVasanItems } from '../hooks/hooks';
import "react-loading-skeleton/dist/skeleton.css";
import AddvasanitemsModal from './../modal/AddvasanitemsModal'
import { DeleteIcon, EditIcon, NDVasanI, NDVegetableI } from '../assets/icons/icon';
import { ButtonWithIcon } from '../components/Common/Buttons';
import EntityListPage from '../components/Common/EntityListPage';
import { getUnitTypes } from '../components/common';

function VasanItemsCopy() {
  const { t } = useTranslation();

  const VasanCard = ({ item, index, onEdit, onDelete }) => (
    <div className="bg-white rounded-xl shadow-card border border-gray-100 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 p-6">
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            {item.name}
          </h3>
          <div className="flex items-center gap-2">
            <NDVegetableI className='w-4 h-4 text-gray-500' />
            <span className="text-sm text-gray-600">{getUnitTypes(item.unitType)}</span>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <ButtonWithIcon title="Edit" variant='secondary' Icon={EditIcon} btnclass="p-[5px] text-green-600 hover:bg-green-50 rounded-md transition-all border border-green-300" iconClass="mr-0" onClick={onEdit} />
          <ButtonWithIcon title="Edit" variant='secondary' Icon={DeleteIcon} iconClass="w-4 h-4 mr-0" btnclass="p-[5px] text-red-600 hover:bg-red-50 rounded-md border border-red-300" onClick={onDelete} />
        </div>
      </div>
    </div>
  );

  const TableRow = ({ item, index, startIndex, onEdit, onDelete }) => (
    <div
      className={`w-full flex py-4 font-medium text-sm text-gray-700 border-b border-gray-100 hover:bg-gray-50 transition-colors duration-200
          ${index % 2 === 0 ? "bg-gray-50/50" : "bg-white"}`}
    >
      <div className="w-[10%] pl-6 flex items-center font-medium text-gray-500">{startIndex + index + 1}</div>
      <div className="w-[45%] flex items-center pr-4">
        <div className="font-semibold text-gray-900 truncate" title={item.name}>{item.name}</div>
      </div>
      <div className="w-[35%] flex items-center pr-4">
        <div className="text-gray-700 truncate" title={getUnitTypes(item.unitType)}>{getUnitTypes(item.unitType)}</div>
      </div>
      <div className="w-[10%] flex items-center">
        <div className="flex items-center gap-2">
          <ButtonWithIcon title="Edit" variant='secondary' Icon={EditIcon} btnclass="p-2 text-green-600 hover:bg-green-50 rounded-md transition-all border border-green-300" iconClass="mr-0" onClick={onEdit} />
          <ButtonWithIcon title="Delete" variant='secondary' Icon={DeleteIcon} iconClass="w-4 h-4 mr-0" btnclass="p-2 text-red-600 hover:bg-red-50 rounded-md border border-red-300" onClick={onDelete} />
        </div>
      </div>
    </div>
  );

  const filterFn = useCallback((list, searchText) => {
    if (!searchText.trim()) return list;

    const v = searchText.toLowerCase();

    return list.filter(item =>
      item.name?.toLowerCase().includes(v)
    );
  }, []);

  const getNoDataDesc = useCallback((searchText) => {
    return searchText ? 'Try adjusting your search terms' : 'Get started by adding your first vasan item';
  }, []);

  return (
    <>
      <EntityListPage
        title={t('VasanItems')}
        subtitle={t('manage_your_vasan_items_and_traditional_products')}
        addButtonText={t('add_new_VasanItems')}
        searchPlaceholder={t('search_Vasan_lbl')}

        fetchHook={useGetAllVasanItems}
        deleteHook={useDeleteVasanItems}
        filterFn={filterFn}

        tableColumns={[
          { key: "#", label: "#", className: "w-[10%]", width: 50 },
          { key: "name", label: t('VasanItems_name'), className: "w-[45%]", width: 200 },
          { key: "unit", label: t('unitType'), className: "w-[35%]", width: 150 },
          { key: "action", label: t('Action'), className: "w-[10%]", width: 80 },
        ]}

        TableRow={TableRow}
        Card={VasanCard}
        AddEditModal={AddvasanitemsModal}

        getNoDataDesc={getNoDataDesc}
        emptyIcon={<NDVasanI />}
        emptyText="No vasan items found"
        buttonText={'Add Vasan Item'}
        deleteMsg={t('delete_VasanItems_confirmation_msg')}
      />

    </>
  )
}

export default VasanItemsCopy